// extracted by mini-css-extract-plugin
export default {"formContent":"InvestorRelationshipForm_formContent__cOPO4"};